/**
 * Copy owned by shared React components rather than by a page.
 *
 * A component under `apps/web-app/src/components/` renders on many screens
 * across several areas, so its strings belong to the component and not to any
 * one page namespace — `detail.section` is used by 32 files across contacts,
 * workspace components, leads, companies and four page-level screens.
 */
export const components = {
  'currency-input': {
    'whole-euro-hint': 'Nur ganze Euro',
  },
  'column-preference': {
    'save-error': 'Spalten konnten nicht gespeichert werden — bitte erneut versuchen.',
    menu: {
      trigger: 'Optionen für Spalte {column}',
      'sort-asc': 'Aufsteigend sortieren',
      'sort-desc': 'Absteigend sortieren',
      'move-left': 'Nach links',
      'move-right': 'Nach rechts',
      hide: 'Spalte ausblenden',
      all: 'Alle Spalten …',
    },
    drag: {
      handle: 'Spalte {column} verschieben',
    },
    trigger: 'Spalten',
    panel: {
      title: 'Spalten',
      hint: 'Ziehen ordnet, der Haken blendet ein und aus. Gilt nur für dich.',
      'always-visible': 'immer sichtbar',
      'new-badge': 'neu',
      'new-columns':
        '{count, plural, one {Die Spalte {names} ist neu dazugekommen und steht am Ende.} other {Die Spalten {names} sind neu dazugekommen und stehen am Ende.}} Ordne sie ein, wo du sie brauchst.',
      'min-visible': 'Mindestens eine Spalte muss sichtbar bleiben.',
      reset: 'Auf Standard zurücksetzen',
      done: 'Fertig',
    },
  },
  'access-choice': {
    label: 'Zugriff',
    all: 'Alle Werkzeuge',
    'all-hint': 'Der Client darf alles, was du in immoOS darfst – auch Werkzeuge, die später dazukommen.',
    selected: 'Ausgewählte Berechtigungen',
    'selected-hint': 'Der Client darf nur, was du hier auswählst. Neue Werkzeuge kommen nicht automatisch dazu.',
    'selection-empty': 'Wähle mindestens eine Berechtigung aus – oder erlaube alle Werkzeuge.',
  },
  'permission-picker': {
    groups: {
      lead: 'Leads',
      deal: 'Deals',
      property: 'Objekte',
      activity: 'Aktivitäten',
      relationship: 'Kontakte & Firmen',
      valuation: 'Bewertungen',
      identity: 'Team & Standorte',
    },
  },
  'select-all-actions': {
    'select-all': 'Alle auswählen',
    'deselect-all': 'Alle abwählen',
  },
  detail: {
    section: {
      add: 'Hinzufügen',
    },
  },
} as const;
